import React from "react";

import { Box, Chip } from "@mui/material";

export default function BlogPostTags({ blogPost }) {
  return (
    <>
      <Box flexDirection="column" display="flex">
        <Box display="flex" gap={1} flexWrap="wrap">
          {blogPost.tags?.map((tag) => (
            <Chip
              key={`tag_${tag.id}`}
              variant="filled"
              size="small"
              label={tag.name}
            />
          ))}
        </Box>
      </Box>
    </>
  );
}
